import React from "react";
import Index from "./index";
import CustomCard from "../../../shared/Card/CustomCard";
import CustomFaqAccordion from "../../../shared/Accordion/CustomFaqAccordion";
import { Dialog } from "primereact/dialog";
import PrimaryButton, { PrimaryButtonOutlined } from "../../../shared/Button/PrimaryButton";
import { CustomInput } from "../../../shared/Input/AllInputs";

export default function FAQ() {
    let { faq, faqData, faqDialogVisible, setFaqDialogVisible, editFaq, handleFaqChange, addUpdateFaq, onHideForm, onDeleteFaq } = Index();

    return (
        <>
            <CustomCard title={"FAQ"} backable={false} buttonTitle="Add FAQ" onClick={setFaqDialogVisible}>
                <CustomFaqAccordion children={faq} onEdit={editFaq} onDelete={onDeleteFaq} />
            </CustomCard>

            <Dialog visible={faqDialogVisible} style={{ width: "30vw" }} header={faqData?._id ? "Update FAQ" : "Add FAQ"} onHide={onHideForm}>
                <div className="w-full">
                    <CustomInput col={12} key="question" label="Question" name="question" data={faqData} onChange={handleFaqChange} />
                    <CustomInput col={12} key="answer" label="Answer" name="answer" data={faqData} onChange={handleFaqChange} />
                </div>

                <div className="flex w-full mb-3 justify-content-end">
                    <PrimaryButton label={faqData?._id ? "Update FAQ" : "Add FAQ"} onClick={addUpdateFaq} />
                    <PrimaryButtonOutlined label="Cancel" onClick={onHideForm} />
                </div>
            </Dialog>
        </>
    );
}
